<template>
	<div @click="handleOnClick && openUpload()" class="cursor-pointer flex">
		<input type="file" ref="file" :multiple="multiple" class="hidden pointer-events-none" :accept="accept" @change="chosedUpload" />
		<slot>
			<font-awesome-icon :icon="['fas', 'upload']" class="w-5 h-5 pr-1 mr-1" size="lg" />
		</slot>
	</div>
</template>

<script>
export default {
	name: 'BaseFileUploader',
	props: {
		accept: { default: 'application/pdf' },
		handleOnClick: { default: true },
		multiple: { default: false },
		maxfiles: { default: false },
		allowUploadInAppContainer: { default: true },
	},
	methods: {
		openUpload() {
			this.$refs.file.click();
		},
		chosedUpload() {
			const files = this.$refs.file.files;
			const reader = new FileReader();
			const splitAccept = this.accept.split(',').map(accept => accept.trim());
			const isValid = [];
			const names = [];

			for (let y = 0; y < files.length; y++) {
				names.push(files[y].name);
				for (let i = 0; i < splitAccept.length; i++) {
					if (files[y].type.startsWith(splitAccept[i])) {
						isValid[y] = true;
					}
				}
			}

			if (files.length !== isValid.length) {
				this.$swal(this.$t('general.attention').toString(), this.$t('incorrect_file_format').toString(), 'warning');
				return false;
			}

			if (this.maxfiles && files.length > this.maxfiles) {
				this.$swal(this.$t('general.attention').toString(), this.$t('max_file_amount', { maxFiles: this.maxfiles }).toString(), 'warning');
				return false;
			}

			this.$emit('update:filename', names.join('<br>'));

			reader.onload = e => {
				this.$emit('input', e.target.result);
			};

			reader.readAsDataURL(files[0]);
		},
	},
};
</script>
